import { render, staticRenderFns } from "./cProvider.vue?vue&type=template&id=6cf6b13f&"
import script from "./cProvider.vue?vue&type=script&lang=js&"
export * from "./cProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports